import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';
import { MapKeyConstant } from '../../../constant/MapKeyConstant';
import { Tutorialsprops } from '../../../constant/tutorialsprops';
import { UtilService } from '../../../util/UtilService';

@Component({
    templateUrl: '../../../template/noop.template.html',
    standalone: false
})
export class TutorialLayoutComponent implements OnChanges {
  private resizeTimeOut;
  private resultTimeOut1;
  @Input() data: any;
  @Output() eventEmit: EventEmitter<string> = new EventEmitter<string>();
  public tutorialCount = 1;
  menuArr: Array<number> = new Array<number>(9);
  public pays_blank_tutorial: object;
  loadingFontObj;
  mapKeyConstant = MapKeyConstant.FC21KEYS;
  _subscriptionScale;
  public contentHeight = 0;
  isPortrait = false;
  constructor(public _utilService: UtilService) {
    this._subscriptionScale = _utilService.scaleChange.subscribe((value) => {
      // console.log('_subKKKKKKscriptionScale');
      this.resizeTimeOut = setTimeout(() => {
        this.isPortrait =
          window.innerWidth > window.innerHeight || window.innerWidth > 1024
            ? false
            : true;
        // console.log('this.isPortrait');
        // console.log(this.isPortrait);
        this.setContentHeight();
        window.clearTimeout(this.resizeTimeOut);
        delete this.resizeTimeOut;
      }, 300);
    });
  }

  setContentHeight = () => {
    this.contentHeight =
      this._utilService.parentHeight != 0
        ? this._utilService.parentHeight
        : window.innerHeight;
    // console.log(this.contentHeight);
  };

  ngOnInit() {
    //console.log("data.currentLanguage",this.data);
    //console.log("data.currentLanguage",this.data.currentLanguage);
    this.loadingFontObj = {
      hy: {
        fontFamily: 'DejaVu-Sans',
        paysContentFontSize: 0.7,
        percentageContentFontSize: 1,
      },
      'zh-Hans': {
        fontFamily: 'HiraginoSansGBW3',
        paysContentFontSize: 1,
        percentageContentFontSize: 1,
      },
      'zh-Hant': {
        fontFamily: 'HiraginoSansGBW3',
        paysContentFontSize: 1,
        percentageContentFontSize: 1,
      },
      cs: {
        fontFamily: 'MyriadPro-BoldCond',
        paysContentFontSize: 1,
        percentageContentFontSize: 1,
      },
      da: {
        fontFamily: 'MyriadPro-BoldCond',
        paysContentFontSize: 1,
        percentageContentFontSize: 1,
      },
      nl: {
        fontFamily: 'MyriadPro-BoldCond',
        paysContentFontSize: 1,
        percentageContentFontSize: 1,
      },
      en: {
        fontFamily: 'MyriadPro-BoldCond',
        paysContentFontSize: 1,
        percentageContentFontSize: 1,
      },
      fi: {
        fontFamily: 'MyriadPro-BoldCond',
        paysContentFontSize: 1,
        percentageContentFontSize: 1,
      },
      fr: {
        fontFamily: 'MyriadPro-BoldCond',
        paysContentFontSize: 1,
        percentageContentFontSize: 1,
      },
      de: {
        fontFamily: 'MyriadPro-BoldCond',
        paysContentFontSize: 1,
        percentageContentFontSize: 1,
      },
      he: {
        fontFamily: 'ArialHebrew-Bold',
        paysContentFontSize: 1.3,
        percentageContentFontSize: 1.3,
      },
      id: {
        fontFamily: 'MyriadPro-BoldCond',
        paysContentFontSize: 1.2,
        percentageContentFontSize: 1,
      },
      it: {
        fontFamily: 'MyriadPro-BoldCond',
        paysContentFontSize: 1,
        percentageContentFontSize: 1,
      },
      ja: {
        fontFamily: 'HiraginoSansGBW3',
        paysContentFontSize: 1,
        percentageContentFontSize: 1,
      },
      ko: {
        fontFamily: 'Adobe 고딕 Std',
        paysContentFontSize: 1,
        percentageContentFontSize: 1,
      },
      nb: {
        fontFamily: 'MyriadPro-BoldCond',
        paysContentFontSize: 1,
        percentageContentFontSize: 1,
      },
      pl: {
        fontFamily: 'MyriadPro-BoldCond',
        paysContentFontSize: 1,
        percentageContentFontSize: 1,
      },
      'pt-BR': {
        fontFamily: 'MyriadPro-BoldCond',
        paysContentFontSize: 1,
        percentageContentFontSize: 1,
      },
      ru: {
        fontFamily: 'MyriadPro-BoldCond',
        paysContentFontSize: 1,
        percentageContentFontSize: 1,
      },
      es: {
        fontFamily: 'MyriadPro-BoldCond',
        paysContentFontSize: 1,
        percentageContentFontSize: 1,
      },
      sv: {
        fontFamily: 'MyriadPro-BoldCond',
        paysContentFontSize: 1,
        percentageContentFontSize: 1,
      },
      th: {
        fontFamily: 'Loma',
        paysContentFontSize: 1,
        percentageContentFontSize: 1,
      },
      tr: {
        fontFamily: 'MyriadPro-BoldCond',
        paysContentFontSize: 1,
        percentageContentFontSize: 1,
      },
      vi: {
        fontFamily: 'Verdana',
        paysContentFontSize: 1,
        percentageContentFontSize: 1,
      },
      ar: {
        fontFamily: 'MyriadPro-BoldCond',
        paysContentFontSize: 1,
        percentageContentFontSize: 1,
      },
      bg: {
        fontFamily: 'MyriadPro-BoldCond',
        paysContentFontSize: 1,
        percentageContentFontSize: 1,
      },
      ee: {
        fontFamily: 'MyriadPro-BoldCond',
        paysContentFontSize: 1,
        percentageContentFontSize: 1,
      },
      ge: {
        fontFamily: 'MyriadPro-BoldCond',
        paysContentFontSize: 1,
        percentageContentFontSize: 1,
      },
      gr: {
        fontFamily: 'MyriadPro-BoldCond',
        paysContentFontSize: 1,
        percentageContentFontSize: 1,
      },
      'hi-IN': {
        fontFamily: 'MyriadPro-BoldCond',
        paysContentFontSize: 1,
        percentageContentFontSize: 1,
      },
      hu: {
        fontFamily: 'MyriadPro-BoldCond',
        paysContentFontSize: 1,
        percentageContentFontSize: 1,
      },
      lt: {
        fontFamily: 'MyriadPro-BoldCond',
        paysContentFontSize: 1,
        percentageContentFontSize: 1,
      },
      kh: {
        fontFamily: 'MyriadPro-BoldCond',
        paysContentFontSize: 1,
        percentageContentFontSize: 1,
      },
      lv: {
        fontFamily: 'MyriadPro-BoldCond',
        paysContentFontSize: 1,
        percentageContentFontSize: 1,
      },
      mt: {
        fontFamily: 'MyriadPro-BoldCond',
        paysContentFontSize: 1,
        percentageContentFontSize: 1,
      },
      my: {
        fontFamily: 'MyriadPro-BoldCond',
        paysContentFontSize: 1,
        percentageContentFontSize: 1,
      },
      ph: {
        fontFamily: 'MyriadPro-BoldCond',
        paysContentFontSize: 1,
        percentageContentFontSize: 1,
      },
      ro: {
        fontFamily: 'MyriadPro-BoldCond',
        paysContentFontSize: 1,
        percentageContentFontSize: 1,
      },
      si: {
        fontFamily: 'MyriadPro-BoldCond',
        paysContentFontSize: 1,
        percentageContentFontSize: 1,
      },
      sk: {
        fontFamily: 'MyriadPro-BoldCond',
        paysContentFontSize: 1,
        percentageContentFontSize: 1,
      },
      'sr-RS': {
        fontFamily: 'MyriadPro-BoldCond',
        paysContentFontSize: 1,
        percentageContentFontSize: 1,
      },
      'ta-IN': {
        fontFamily: 'MyriadPro-BoldCond',
        paysContentFontSize: 0.9,
        percentageContentFontSize: 1,
      },
      ua: {
        fontFamily: 'MyriadPro-BoldCond',
        paysContentFontSize: 1,
        percentageContentFontSize: 1,
      },
    };
    /*
     * "LANG00783":"Pays 1 to 1",
     "LANG00784":"Pays 2 to 1",
     "LANG00785":"Pays 3 to 1",
     "LANG00786":"Pays 3 to 2",
     "LANG00787":"Pays 4 to 1",
     "LANG00788":"Pays 5 to 1",
     "LANG00789":"Pays 6 to 5",
     "LANG00790":"Pays 7 to 2",
     "LANG00791":"Pays 7 to 5",
     "LANG00792":"Pays 8 to 5",
     "LANG00793":"Pays 9 to 5",
     */
    this.pays_blank_tutorial = {
      TN_pays_blank_position_0: [],
      TN_pays_blank_position_1: [],
      TN_pays_blank_position_2: [],
      TN_pays_blank_position_3: [],
      TN_pays_blank_position_4: [],
      TN_pays_blank_position_5: [],
      TN_pays_blank_position_6: [],
      TN_pays_blank_position_7: [],
      TN_pays_blank_position_8: [
        {
          paysContent: 'LANG00886',
          percentageContent:
            this.data.currentLanguage == 'ar' ? '%200' : '200%',
          width: '9.5%',
          height: '8%',
          left: '46%',
          top: '74%',
        },
      ],
      TN_pays_blank_position_9: [
        {
          paysContent: 'LANG00888',
          percentageContent:
            this.data.currentLanguage == 'ar' ? '%150' : '150%',
          width: '9.5%',
          height: '8%',
          left: '46%',
          top: '74%',
        },
      ],
      TN_pays_blank_position_10: [
        {
          paysContent: 'LANG00885',
          percentageContent:
            this.data.currentLanguage == 'ar' ? '%100' : '100%',
          width: '9.5%',
          height: '8%',
          left: '46%',
          top: '74%',
        },
      ],
      TN_pays_blank_position_11: [
        {
          paysContent: 'LANG00885',
          percentageContent:
            this.data.currentLanguage == 'ar' ? '%100' : '100%',
          width: '9.5%',
          height: '8%',
          left: '46%',
          top: '74%',
        },
      ],
      TN_pays_blank_position_12: [],
      TN_pays_blank_position_13: [],
      TN_pays_blank_position_14: [],
      TN_pays_blank_position_15: [],
      TN_pays_blank_position_16: [
        {
          paysContent:
            this.data.currentLanguage == 'ar' ||
            this.data.currentLanguage == 'he'
              ? 'LANG00886'
              : 'LANG00886',
          percentageContent:
            this.data.currentLanguage == 'ar' ? '%200' : '200%',
          width: '9.5%',
          height: '8%',
          left:
            Tutorialsprops[this.data.currentLanguage]
              .TN_pays_blank_position_16_Left + '%',
          top:
            Tutorialsprops[this.data.currentLanguage]
              .TN_pays_blank_position_16_Top + '%',
        },
      ],
      TN_pays_blank_position_17: [
        {
          paysContent:
            this.data.currentLanguage == 'ar' ||
            this.data.currentLanguage == 'he'
              ? 'LANG00886'
              : 'LANG00886',
          percentageContent:
            this.data.currentLanguage == 'ar' ? '%200' : '200%',
          width: '9.5%',
          height: '8%',
          left:
            Tutorialsprops[this.data.currentLanguage]
              .TN_pays_blank_position_17_Left + '%',
          top:
            Tutorialsprops[this.data.currentLanguage]
              .TN_pays_blank_position_17_Top + '%',
          // 'left': (this.data.currentLanguage == 'ar' || this.data.currentLanguage == 'he' ? '65%' : ' 27%'),
          // 'top': (this.data.currentLanguage == 'ar' || this.data.currentLanguage == 'he' ? '80%' : '73%')
        },
      ],
      TN_pays_blank_position_18: [
        {
          paysContent:
            this.data.currentLanguage == 'ar' ||
            this.data.currentLanguage == 'he'
              ? 'LANG00892'
              : 'LANG00891',
          percentageContent:
            this.data.currentLanguage == 'ar'
              ? '%350'
              : this.data.currentLanguage == 'he'
              ? '350%'
              : '120%',
          width: '9.5%',
          height: '8%',
          left: '27.3%',
          top: this.data.currentLanguage == 'es' ? '79.5%' : '78%',
        },
        {
          paysContent:
            this.data.currentLanguage == 'ar' ||
            this.data.currentLanguage == 'he'
              ? 'LANG00886'
              : 'LANG00893',
          percentageContent:
            this.data.currentLanguage == 'ar'
              ? '%200'
              : this.data.currentLanguage == 'he'
              ? '200%'
              : '140%',
          width: '9.5%',
          height: '8%',
          left: '39.6%',
          top: this.data.currentLanguage == 'es' ? '79.5%' : '78%',
        },
        {
          paysContent:
            this.data.currentLanguage == 'ar' ||
            this.data.currentLanguage == 'he'
              ? 'LANG00893'
              : 'LANG00886',
          percentageContent:
            this.data.currentLanguage == 'ar'
              ? '%140'
              : this.data.currentLanguage == 'he'
              ? '140%'
              : '200%',
          width: '9.5%',
          height: '8%',
          left: '52%',
          top: this.data.currentLanguage == 'es' ? '79.5%' : '78%',
        },
        {
          paysContent:
            this.data.currentLanguage == 'ar' ||
            this.data.currentLanguage == 'he'
              ? 'LANG00891'
              : 'LANG00892',
          percentageContent:
            this.data.currentLanguage == 'ar'
              ? '%120'
              : this.data.currentLanguage == 'he'
              ? '120%'
              : '350%',
          width: '9.5%',
          height: '8%',
          left: '64.6%',
          top: this.data.currentLanguage == 'es' ? '79.5%' : '78%',
        },
      ],
      TN_pays_blank_position_19: [
        {
          paysContent: 'LANG00886',
          percentageContent:
            this.data.currentLanguage == 'ar' ? '%200' : '200%',
          width: '9.5%',
          height: '8%',
          left:
            this.data.currentLanguage == 'ar' ||
            this.data.currentLanguage == 'he'
              ? '63%'
              : '26%',
          top: '23%',
        },
        {
          paysContent: 'LANG00888',
          percentageContent:
            this.data.currentLanguage == 'ar' ? '%150' : '150%',
          width: '9.5%',
          height: '8%',
          left:
            this.data.currentLanguage == 'ar' ||
            this.data.currentLanguage == 'he'
              ? '63%'
              : '26%',
          top: '32%',
        },
        {
          paysContent: 'LANG00885',
          percentageContent:
            this.data.currentLanguage == 'ar' ? '%100' : '100%',
          width: '9.5%',
          height: '8%',
          left:
            this.data.currentLanguage == 'ar' ||
            this.data.currentLanguage == 'he'
              ? '63%'
              : '26%',
          top: '42%',
        },
        {
          paysContent: 'LANG00885',
          percentageContent:
            this.data.currentLanguage == 'ar' ? '%100' : '100%',
          width: '9.5%',
          height: '8%',
          left:
            this.data.currentLanguage == 'ar' ||
            this.data.currentLanguage == 'he'
              ? '63%'
              : '26%',
          top: '51%',
        },
        {
          paysContent: 'LANG00885',
          percentageContent:
            this.data.currentLanguage == 'ar' ? '%100' : '100%',
          width: '9.5%',
          height: '8%',
          left:
            this.data.currentLanguage == 'ar' ||
            this.data.currentLanguage == 'he'
              ? '63%'
              : '26%',
          top: '61%',
        },
        {
          paysContent: 'LANG00886',
          percentageContent:
            this.data.currentLanguage == 'ar' ? '%200' : '200%',
          width: '9.5%',
          height: '8%',
          left:
            this.data.currentLanguage == 'ar' ||
            this.data.currentLanguage == 'he'
              ? '63%'
              : '26%',
          top: '70%',
        },
        {
          paysContent: 'LANG00886',
          percentageContent:
            this.data.currentLanguage == 'ar' ? '%200' : '200%',
          width: '9.5%',
          height: '8%',
          left:
            this.data.currentLanguage == 'ar' ||
            this.data.currentLanguage == 'he'
              ? '63%'
              : '26%',
          top: '80%',
        },
      ],
      TN_pays_blank_position_20: [],
      TN_pays_blank_position_21: [],
    };
  }

  ngOnChanges(info) {
    if (info.data) {
      this.data = info.data.currentValue;
      this.tutorialCount = this.data.index;
    }
  }

  arrowClick(value) {
    const contentObj: Object = this.data.tutorialContent;
    switch (value) {
      case 'left':
        this.tutorialCount > 0
          ? this.tutorialCount--
          : (this.tutorialCount = Object.keys(contentObj).length - 2);
        break;
      case 'right':
        this.tutorialCount < Object.keys(contentObj).length - 2
          ? this.tutorialCount++
          : (this.tutorialCount = 0);
        break;
      default:
        break;
    }
    //console.log(this.tutorialCount);
  }

  @HostListener('document:keydown', ['$event'])
  onKeyPress(event: KeyboardEvent) {
    if (event.key.toLowerCase() == 'escape') {
      this.onCloseClick(event);
    }
    if (
      event.key.toLowerCase() == 'arrowleft' ||
      event.key.toLowerCase() == 'uikeyinputleftarrow'
    ) {
      this.arrowClick('left');
    }
    if (
      event.key.toLowerCase() == 'arrowright' ||
      event.key.toLowerCase() == 'uikeyinputrightarrow'
    ) {
      this.arrowClick('right');
    }
  }

  onCloseClick = (event = null) => {
    this.eventEmit.emit('close');
  };
  onHomeClick = (event = null) => {
    this.tutorialCount = 0;
  };

  menuClick = (value) => {
    //console.log(value);
    this.tutorialCount = value;
    if (this.data.game === 'fcb') {
      if (value === 9) {
        this.tutorialCount = 8;
      }
      if (value === 8) {
        this.tutorialCount = 9;
      }
    }
  };

  ngAfterViewInit() {
    if (this.data.index !== undefined) {
      this.resultTimeOut1 = setTimeout(() => {
        this.tutorialCount = this.data.index;
        window.clearTimeout(this.resultTimeOut1);
      }, 1);
    }
  }
  ngOnDestroy(): void {
    if (this.resizeTimeOut) {
      window.clearTimeout(this.resizeTimeOut);
    }
    if (this.resultTimeOut1) {
      window.clearTimeout(this.resultTimeOut1);
    }
    if (this._subscriptionScale) {
      this._subscriptionScale.unsubscribe();
    }
    delete this._subscriptionScale;
    delete this.resizeTimeOut;
    delete this.resultTimeOut1;
  }
}
